import { cn } from "@/lib/utils";
import { Separator } from "@/components/ui/separator";

interface ReadingTimeDisplayProps {
  totalWordCount: number;
  estimatedTime: number;
  sectionWordCount?: number;
  layout?: "horizontal" | "vertical";
  className?: string;
}

export const ReadingTimeDisplay = ({
  totalWordCount,
  estimatedTime,
  sectionWordCount,
  layout = "vertical",
  className,
}: ReadingTimeDisplayProps) => {
  if (layout === "horizontal") {
    return (
      <div className={cn("flex justify-between text-sm text-gray-600", className)}>
        <div>Words: {totalWordCount}</div>
        <div>Est. time: {estimatedTime}min</div>
      </div>
    );
  }

  return (
    <div className={cn("text-xs", className)}>
      <div className="flex items-center">
        <div className="pl-2 pr-4">
          <div className="text-muted-foreground mb-1">Words (total)</div>
          <div className="font-semibold">{totalWordCount}</div>
        </div>
        <Separator orientation="vertical" className="h-full" />
        <div className="px-4">
          <div className="text-muted-foreground mb-1">Est. time</div>
          <div className="font-semibold">{estimatedTime}min</div>
        </div>
        <Separator orientation="vertical" className="h-full" />
        <div className="px-4">
          <div className="text-muted-foreground mb-1">Words <span className="text-blue-500">(section)</span></div>
          <div className="font-semibold">{sectionWordCount || totalWordCount}</div>
        </div>
      </div>
    </div>
  );
};

